/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type access_type = "admin" | "none" | "user" | "vendor" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AccountsNavDrawer_account$ref: FragmentReference;
declare export opaque type AccountsNavDrawer_account$fragmentType: AccountsNavDrawer_account$ref;
export type AccountsNavDrawer_account = {|
  +first_name: ?string,
  +last_name: ?string,
  +org: ?{|
    +id: string,
    +name: string,
  |},
  +authorizedApps: $ReadOnlyArray<{|
    +name: ?string,
    +access: ?access_type,
  |}>,
  +$refType: AccountsNavDrawer_account$ref,
|};
export type AccountsNavDrawer_account$data = AccountsNavDrawer_account;
export type AccountsNavDrawer_account$key = {
  +$data?: AccountsNavDrawer_account$data,
  +$fragmentRefs: AccountsNavDrawer_account$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AccountsNavDrawer_account",
  "type": "Account",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "org",
      "storageKey": null,
      "args": null,
      "concreteType": "Org",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "authorizedApps",
      "storageKey": null,
      "args": null,
      "concreteType": "AuthorizedApp",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "access",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '54e9dfd8fb68ec5343e34b5fda99460b';
module.exports = node;
